module.exports = __webpack_public_path__ + "img/hjalphem.a5989a04.jpg";